module.exports = __webpack_public_path__ + "img/email-container-1.75cea236.png";